import { render, staticRenderFns } from "./CreateIns.vue?vue&type=template&id=74d6e869&"
import script from "./CreateIns.vue?vue&type=script&lang=js&"
export * from "./CreateIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports